<template>
  <q-page padding>
    <PageHeader
      title="Recebimento de Ferramenta"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md items-center"
    >
      <div class="col-md-2 col-xs-5">
        <div class="texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div class="col-md-3 col-xs">
        <div class="texto-titulo-input">Selecione o Tipo de Recebimento</div>
        <q-select
          v-model="recebimento"
          behavior="menu"
          :options="options.optionsRecebimento"
          dense
          label="Selecione o Tipo"
          label-color="grey-6"
          class="input"
          outlined
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const router = useRouter();
    const recebimento = ref({
      label: "",
      value: "",
    });
    const options = ref({
      optionsRecebimento: [
        {
          label: "Entrada com Requisição",
          value: "ferramentaria-recebimento-entrada-requisicao",
        },
        {
          label: "Criar Ativo por Catálogo",
          value: "ferramentaria-criar-ferramenta-catalogo",
        },
      ],
    });

    watch(
      () => recebimento.value.value,
      () => {
        if (recebimento.value.value !== "") {
          router.push({ name: recebimento.value.value });
        }
      }
    );

    return { recebimento, options };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
}
</style>
